import React from 'react';
import { Link } from 'react-router-dom';
import './Text.scss';
import { PropTypes } from 'prop-types';
import Icon from '../Icons/Icon';

const Text = ({ text }) => {
  const className = 'c-Text';

  const isArrText = Array.isArray(text);

  const renderArrayTitle = () => {
    return text.map((textData, key) => {
      const {
        text: strText,
        isHighlighted,
        isUnderlined,
        isBolder,
        isAnchorText,
        isNewLine,
        isStrikeThrough,
        isIcon,
        iconName,
        link,
        ...rest
      } = textData;

      if (isIcon && iconName) {
        return (
          <span key={key} className={`${className}--icon`} {...rest}>
            <Icon name={iconName} />
          </span>
        );
      }

      const spanClass = [
        isHighlighted ? ` ${className}--highlighted` : '',
        isBolder ? ` ${className}--bolder` : '',
        isAnchorText ? ` ${className}--anchor` : '',
        isNewLine ? ` ${className}--newline` : '',
        isStrikeThrough ? ` ${className}--striked` : '',
        isUnderlined ? ` ${className}--underlined` : '',
        link ? ` ${className}--link` : '',
      ].join('');

      if (link) {
        return (
          <span key={key} className={spanClass} {...rest}>
            <Link to={link} title={strText}>
              {strText}
            </Link>
          </span>
        );
      }

      return (
        <span key={key} className={spanClass} {...rest}>
          {strText}
        </span>
      );
    });
  };

  return <p className={className}>{isArrText ? renderArrayTitle() : text}</p>;
};

export const TextArrType = PropTypes.arrayOf(
  PropTypes.shape({
    text: PropTypes.string.isRequired,
    isHighlighted: PropTypes.bool,
    isBolder: PropTypes.bool,
    isAnchorText: PropTypes.bool,
    link: PropTypes.string,
  })
);

export const TextType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  TextArrType,
]);

Text.propTypes = {
  text: TextType,
};

export default Text;
